import { CircleCheck } from 'lucide-react';
export default function ModuleItem({
  module,
  index,
  active,
  onClick,
}) {
  return (
    <div
      onClick={onClick}
      className={`p-4 rounded-xl cursor-pointer border transition
        ${
          active
            ? "border-blue-500 bg-blue-50"
            : "hover:bg-gray-50"
        }
      `}
    >
      <div className="flex gap-3 items-start">
        <div className="mt-1">
          {module.is_completed ? (
            <span className="text-green-400"><CircleCheck /></span>
          ) : (
            <span className="text-gray-400">○</span>
          )}
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Module {module.order}
          </p>
          <p className="font-medium">{module.title}</p>
          <p className="text-xs text-gray-500 mt-1">
            {Math.ceil(module.duration_seconds / 60)} min
          </p>
        </div>
      </div>
    </div>
  );
}
